/* @flow */
import type { ReduxState, Action, Fetchable, Category } from '../../types';
// ===========================
//   STATE TYPE
// ===========================
export type CategoriesState = {
  categories: Fetchable<Category[]>,
};

// ===========================
//   INITIAL STATE
// ===========================
export const initialState: CategoriesState = {
  categories: { fetching: false },
};

// ===========================
//   REDUCER
// ===========================
export default (state: CategoriesState = initialState, action: Action): CategoriesState => {
  switch (action.type) {
    case 'FETCH_CATEGORIES_REQUEST': {
      return {
        ...state,
        categories: { fetching: true },
      };
    }
    case 'FETCH_CATEGORIES_SUCCESS': {
      const data = action.payload;
      return {
        ...state,
        categories: { data, fetching: false },
      };
    }
    case 'FETCH_CATEGORIES_FAILURE': {
      const error = action.payload;
      return {
        ...state,
        categories: { error, fetching: false },
      };
    }
    case 'LOGOUT_SUCCESS':
      return initialState;

    default: {
      return state;
    }
  }
};

// ===========================
//   SELECTORS
// ===========================

export const getCategories = (state: ReduxState): Fetchable<Category[]> => {
  return state.categories.categories;
};
